import { useEffect, useRef } from 'react';

// ============================================================================
// NOTIFICATION TOAST - Replaces all alert() calls
// ============================================================================

export function NotificationToast({ message, type = 'success', onClose }) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    const timer = setTimeout(() => closeRef.current(), 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`notification-toast notification-${type}`} onClick={onClose}>
      <div className="notification-content">
        <i className={`fas fa-${type === 'success' ? 'check-circle' : 'exclamation-circle'}`}></i>
        <span>{message}</span>
      </div>
      <button className="notification-close" onClick={onClose}>
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
}
